import files from './files'

const settings = {
    files: Object.assign(files, files),
}

export default settings